import React from "react";
import { colors, fontSize, fontWeight } from "theme/defaultStyle";
import OverflowTooltip from "../overflow-tooltip";

// Validation line: below the box, left-aligned, clipped with an ellipsis. The full
// text sits in a tooltip anchored directly beneath the message and left-aligned to
// it (bottom-start); OverflowTooltip only shows it when the text actually overflows.
const FieldError = ({ message }: { message?: string }) =>
  message ? (
    <OverflowTooltip
      tooltip={message}
      text={message}
      placement="bottom-start"
      style={{
        color: colors.red01,
        fontSize: fontSize.small,
        fontWeight: fontWeight.normal1,
        textAlign: "left",
        maxWidth: "100%",
      }}
    />
  ) : null;
export default FieldError;